module.exports = "<div class=\"income-graph\">\n  <canvas class=\"chart\" #barChart>{{ chart }}</canvas>\n</div>"